(() => {
  const mainContent = document.getElementById('MainContent');
  const leadTimeHeading = document.getElementById('lead-time');
  const scriptTag = document.getElementById('lead-times');

  if (!mainContent || !leadTimeHeading) {
    return;
  }

  if (!scriptTag) {
    console.warn("Script tag with ID 'lead-times' not found.");
    return;
  }

  const jsonString = scriptTag.textContent;

  try {
    const productLeadTimes = JSON.parse(jsonString);

    function updateLeadTime(evt) {
      const variantId = evt.detail.variantId;

      if (!variantId) {
        return;
      }

      const foundLeadTime = productLeadTimes.find(item => item.variantId === variantId);

      if (!foundLeadTime || !foundLeadTime.leadTime) {
        return;
      }

      leadTimeHeading.textContent = foundLeadTime.leadTime;
    }

    mainContent.addEventListener('variant:update', updateLeadTime);
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }
})();